import type { Book as BookType, classDataProps } from "../types/common";
import GroupIcon from "@mui/icons-material/Group";

export const Book = ({
  book,
  classData,
  selectBookId,
  setSelectBookId,
}: {
  book: BookType;
  classData?: classDataProps[];
  selectBookId: string;
  setSelectBookId: (bookId: string) => void;
}) => {
  return (
    <div
      onClick={() => {
        setSelectBookId(book._id);
      }}
      className={`md:block hidden cursor-pointer flex-shrink-0 w-40 h-52 overflow-visible rounded-lg shadow-md transition-all duration-300 select-none relative group hover:z-50
        ${
        selectBookId === book._id
          ? "outline outline-3 outline-secondary outline-offset-4"
          : "hover:shadow-xl hover:scale-105 hover:-translate-y-1"
      }
      `} 
    >
      {book.bookUrl ? (
        <img className="h-full w-full object-cover" src={book.bookUrl} alt={`${book.bookDesc} 封面`} />
      ) : (
        <div className="h-full w-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
          <div className="text-center p-4">
            <div className="text-3xl mb-2">📚</div>
            <div className="text-blue-700 font-medium text-sm">{book.bookDesc}</div>
          </div>
        </div>
      )}
      {Array.isArray(classData) && classData.length > 0 ? (
        <div className="absolute bottom-2 left-0 items-center justify-center group-hover:flex hidden">
          {classData.map((item: classDataProps, index) => {
            // 確保 item 存在
            if (!item) return null;
            
            return (
              <span
                key={item._id || index}
                className="text-white w-fit h-fit px-1 py-.5 bg-black/50 rounded-r-sm text-nowrap"
              >
                {index === 0 && <GroupIcon sx={{ mr: 1 }} />}
                {item.className}
                {index !== classData.length - 1 && "、"}
              </span>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};